import { render, staticRenderFns } from "./PainterSuperTalk.vue?vue&type=template&id=ebbd5cde&scoped=true"
import script from "./PainterSuperTalk.vue?vue&type=script&lang=js"
export * from "./PainterSuperTalk.vue?vue&type=script&lang=js"
import style0 from "./PainterSuperTalk.vue?vue&type=style&index=0&id=ebbd5cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbd5cde",
  null
  
)

export default component.exports